var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4904 10.3158H12.1924V14.9594H18.6466C18.3683 16.4604 17.524 17.73 16.2513 18.5805C15.1756 19.2997 13.8028 19.725 12.1892 19.725C9.06534 19.725 6.423 17.6143 5.47863 14.778C5.24098 14.0588 5.10339 13.2896 5.10339 12.4984C5.10339 11.7073 5.24098 10.938 5.47863 10.2188C6.42612 7.38573 9.06847 5.27498 12.1924 5.27498C13.9529 5.27498 15.5321 5.88163 16.7766 7.0699L20.2164 3.62704C18.1369 1.68827 15.4257 0.5 12.1924 0.5C7.50495 0.5 3.44919 3.18925 1.47603 7.11055C0.662997 8.73036 0.200195 10.5628 0.200195 12.5016C0.200195 14.4403 0.662997 16.2696 1.47603 17.8894C3.44919 21.8107 7.50495 24.5 12.1924 24.5C15.432 24.5 18.1463 23.4243 20.1288 21.5919C22.3959 19.503 23.7061 16.426 23.7061 12.7705C23.7061 11.9199 23.6311 11.1038 23.4904 10.3158Z",
    fill: "#2D3436"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.1a36639ef3a35cc2845f96904955b7d0.svg";
export { ForwardRef as ReactComponent };